import React from 'react';
import { styled, Typography } from '@mui/material';

export const RecordMetrics = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  gap: theme.spacing(1.5),
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

const Card = styled('div')(({ theme }) => ({
  padding: theme.spacing(1.25, 1.5),
  borderRadius: theme.shape.borderRadius,
  background: theme.palette.grey[50],
  border: `1px solid ${theme.palette.divider}`,
}));

// "1 fechado" / "3 fechados"
export function plural(count: number, singular: string, pluralWord: string) {
  return `${count} ${count === 1 ? singular : pluralWord}`;
}

interface RecordMetricProps {
  label: string;
  value: string;
  helpers: string[];
}

export const RecordMetric: React.FC<RecordMetricProps> = ({ label, value, helpers }) => (
  <Card>
    <Typography variant="caption" color="textSecondary">
      {label}
    </Typography>
    <Typography variant="h6" fontWeight={700} color="primary">
      {value}
    </Typography>
    {helpers.map(helper => (
      <Typography key={helper} variant="caption" color="textSecondary" display="block">
        {helper}
      </Typography>
    ))}
  </Card>
);
